export default {
  customerUrl: null,
  list: null,
  loading: false
}
